export default __webpack_public_path__ + "static/media/doctor5.87f65b9d.jpg";